import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private http: HttpClient) { }

  getAllInventorySettings(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Product/InventorySettings`)
  }

  updateInventorynveSetting(obj) {
    return this.http.put<any>(`${environment.inventoryURl}Product/InventorySettings`, obj)
      .toPromise()
      .then(res => res);

  }

  setDefaultTax(taxId: number) {
    return this.http.get<any>(`${environment.inventoryURl}Tax/SetDefaultTax?taxId=${taxId}`);
  }

  getAllTrackingDefaultSettings(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting/ListAllTrackingSettingDefault`);
  }

  getOrganizationTrackingDefaultSettings(serilTypeId): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting?typeId=${serilTypeId}`);
  }

  updateDefaultTracking(data) {
    return this.http.post<any>(`${environment.inventoryURl}TrackingSetting`, data);
  }

  disableTrackingDefaultSettings(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting/DisableTracking`);
  }

  getTrackingOptionById(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting/${id}`);
  }

  updateTrackingOption(data): Observable<any> {
    return this.http.put<any>(`${environment.inventoryURl}TrackingSetting`, data);
  }

  getAllCustomFieldTypes(id): Observable<any> {
    return this.http.get<any>(`${environment.configUrl}Configuration/FormControls?objectId=${id}`);
  }

  getAllGroups(parentGroupId?) {
    let params = new HttpParams();
    params = (parentGroupId ? params.append('parentGroupId', parentGroupId) : params)
    return this.http.get<any>(`${environment.inventoryURl}Group`, { params: params });
  }

  getAllGroupTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  addBatchList(data) {
    return this.http.post<any>(`${environment.coreUrl}Type`, data)
  }

  updateBatchList(data) {
    return this.http.put<any>(`${environment.coreUrl}Type`, data)
  }

  deleteBatchList(batchId) {
    return this.http.delete<any>(`${environment.coreUrl}Type/${batchId}`)
  }

  confirmDelete(batchId : number){
    return this.http.get<any>(`${environment.inventoryURl}Product/CheckBatchAssociation?batchId=${batchId}`);
  }

  getAllCurrencies() {
    return this.http.get<any>(
        `${environment.coreUrl}CurrencyUnit/GetAllCountryCurrency`
    );
}

}
